import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrackAppHomeComponent } from './track-app-home/track-app-home.component';
import { AppTrackComponent } from './track-app-home/app-track/app-track.component';
import { RetrieveAppComponent } from './track-app-home/retrieve-app/retrieve-app.component';
import { TrackAppErrorComponent } from './track-app-error/track-app-error.component';

const routes: Routes = [
  { path: '', component: TrackAppHomeComponent },
  {
     path: 'track-app-partner',
     component: TrackAppHomeComponent,
  },
  { path: 'track-partner-error', component: TrackAppErrorComponent },
]

  //{ path: 'app-track', component: AppTrackComponent },
  // { path: 'retrieve-app', component:  RetrieveAppComponent},



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrackAppPartnerRoutingModule { }
